import React from 'react';
import { useParams } from 'react-router-dom';
import OffboardingClient from '../components/Client/OffBoardingClient';
import OffboardingCounsellor from '../components/Counsellor/OffBoardingCounsellor';
import ThemeBackground from '../components/Layout/ThemeBackground';

const Offboarding: React.FC = () => {
  const { type } = useParams<{ type: string; id: string }>();

  // Render the appropriate component based on the type parameter
  if (type === 'client') {
    return <OffboardingClient />;
  } else if (type === 'counsellor') {
    return <OffboardingCounsellor />;
  }

  // Handle invalid type
  return (
    <ThemeBackground variant="full">
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center glass-card p-8">
          <div className="text-red-400 mb-4">Invalid offboarding type</div>
          <p className="theme-text-secondary mb-4">
            Please specify whether you want to offboard a client or a counsellor.
          </p>
        </div>
      </div>
    </ThemeBackground>
  );
};

export default Offboarding;